<div class="container-state-separator">
    <mat-divider *ngIf="showDivider"></mat-divider>
    <div class="background-state-separator">
        <div class="state-separator"
            [ngStyle]="{'background-color': isCreateTransaction ? '#5C5B5B33' : (statePublicHelper.getStateDetail(state, transactionPrivate).color + '1a')}">
            <img *ngIf="!isCreateTransaction" src="https://panel.saldo.com.ar/img/states-public/{{state}}.png"
                alt="Estado de la transacción">

            <ng-container *ngIf="temporaryState; else originalState">
                <p class="paragraph-with-overflow state-title temporary-state"
                    [ngStyle]="{'color': isCreateTransaction ? '#1577D5' : statePublicHelper.getStateDetail(state, transactionPrivate).color}">
                    {{ temporaryState }}
                </p>
            </ng-container>

            <ng-template #originalState>
                <p class="paragraph-with-overflow state-title"
                matTooltipClass="tooltip-info"
                    [matTooltipDisabled]="disabledTooltip"
                    [ngStyle]="{'color': isCreateTransaction ? '#5C5B5B' : statePublicHelper.getStateDetail(state, transactionPrivate).color}"
                    matTooltip="{{isCreateTransaction ? 'Creaste tu pedido' : statePublicHelper.getStateDetail(state, transactionPrivate).description}}">
                    {{isCreateTransaction ? 'Creaste tu pedido' :
                    statePublicHelper.getStateDetail(state, transactionPrivate).title}}
                </p>
            </ng-template>
        </div>
        <!-- <p>{{transactionPrivate | json}}</p> -->
    </div>
</div>
